import RSAA from 'redux-api-middleware/lib/RSAA';
import {
  METHOD_GET,
  OFFER_CASE_ID,
  METHOD_POST,
  CASE_TYPE_NTB,
  EXISTING_NEW_BUSINESS,
  METHOD_PUT,
  NAVIGATE_TO_SUBMISSION_PAGE,
  CASE_ID
} from '../../utils/constants';
import { getQueryStringValueByName, getHeaders, getPayload } from '../../utils';
import { technicalErrorPage, submitEvidenceCall } from '../../store/dataCapture';
import { submitOfferPayload } from './payloads';
import { redirectBasesOnTaskUri } from './action.helper';
import { selectors as caseSelector } from '../../infrastructure/cases';
export const GET_OFFER = 'GET_OFFER';
export const GET_OFFER_SUCCESS = 'GET_OFFER_SUCCESS';
export const GET_OFFER_FAILED = 'GET_OFFER_FAILED';
export const REQUSEST_LETTER_CODE = 'REQUSEST_LETTER_CODE';
export const LETTER_CODE_SUCCESS = 'LETTER_CODE_SUCCESS';
export const LETTER_CODE_FAILED = 'LETTER_CODE_FAILED';
export const SUBMIT_OFFER = 'SUBMIT_OFFER';
export const SUBMIT_OFFER_SUCCESS = 'SUBMIT_OFFER_SUCCESS';
export const SUBMIT_OFFER_FAILED = 'SUBMIT_OFFER_FAILED';
export const GET_NEXT_CALL = 'GET_NEXT_CALL';
export const GET_NEXT_CALL_SUCCESS = 'GET_NEXT_CALL_SUCCESS';
export const GET_NEXT_CALL_FAILED = 'GET_NEXT_CALL_FAILED';
export const FROM_OFFER_FLOW = 'offer_flow';
const OFFER_CASE_TYPE = 'caseType';

export const retrieveOffers = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/bsap/${caseType()}/${getQueryStringValueByName(
      OFFER_CASE_ID
    )}/tasks/offers`,
    method: METHOD_GET,
    headers: getHeaders(),
    types: [
      {
        type: GET_OFFER,
        meta: { isOfferLoaded: true }
      },
      {
        type: GET_OFFER_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: {
          isOfferLoaded: false
        }
      },
      {
        type: GET_OFFER_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), isOfferLoaded: false };
        }
      }
    ]
  }
});

export const authenticateLetterCode = data => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/bsap/${caseType()}/${getQueryStringValueByName(
      OFFER_CASE_ID
    )}/tasks/lettercode`,
    method: METHOD_POST,
    headers: getHeaders(),
    body: JSON.stringify({ lettercode: data.authcode }),
    types: [
      {
        type: REQUSEST_LETTER_CODE,
        meta: { loading: true }
      },
      {
        type: LETTER_CODE_SUCCESS,
        meta: {
          nextAction: getNextCall(),
          loading: false
        }
      },
      {
        type: LETTER_CODE_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

const SUBMIT_OFFER_ACTION = 'SUBMIT_OFFER_ACTION';
export const submitOffer = () => ({
  type: SUBMIT_OFFER_ACTION,
  meta: {
    nextAction: dispatch => {
      dispatch(acceptOffer());
    }
  }
});

export const acceptOffer = () => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/bsap/${caseType()}/${getQueryStringValueByName(
      OFFER_CASE_ID
    )}/tasks/offers/actions/decision`,
    method: METHOD_PUT,
    headers: getHeaders(),
    body: state => submitOfferPayload(state),
    types: [
      {
        type: SUBMIT_OFFER,
        meta: { loading: true }
      },
      {
        type: SUBMIT_OFFER_SUCCESS,
        meta: (_action, _state) => ({
          nextAction: dispatch => {
            dispatch(submitEvidenceCall('', caseType(), FROM_OFFER_FLOW));
          },
          loading: true
        })
      },
      {
        type: SUBMIT_OFFER_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

export const getNextCall = isSubmitFlow => ({
  [RSAA]: {
    endpoint: `:api_paas_url/banks/:bank_id/cases/bsap/${caseType()}/${getQueryStringValueByName(
      CASE_ID
    ) || getQueryStringValueByName(OFFER_CASE_ID)}/tasks/next`,
    method: METHOD_GET,
    headers: getHeaders(),
    types: [
      {
        type: GET_NEXT_CALL,
        meta: { loading: !isSubmitFlow ? true : false }
      },
      {
        type: GET_NEXT_CALL_SUCCESS,
        payload: (action, state, res) => getPayload(action, state, res),
        meta: (_action, state, res) =>
          redirectBasesOnTaskUri(res.json.task_uri, caseSelector.getJointLinkCode(state))
      },
      {
        type: GET_NEXT_CALL_FAILED,
        meta: () => {
          return { nextAction: technicalErrorPage(), loading: false };
        }
      }
    ]
  }
});

export const caseType = () =>
  getQueryStringValueByName(OFFER_CASE_TYPE) === CASE_TYPE_NTB
    ? CASE_TYPE_NTB
    : EXISTING_NEW_BUSINESS;

export const redirectToSubmission = () => ({
  nextAction: getRedirectSubmitionPageAction(),
  loading: false
});

const getRedirectSubmitionPageAction = () => ({
  type: NAVIGATE_TO_SUBMISSION_PAGE,
  redirect: {
    to: NAVIGATE_TO_SUBMISSION_PAGE
  }
});
